import { h, render } from 'preact'; // eslint-disable-line no-unused-vars

export const BathsIcon = () => (
  <div className="baths-icon icon-wrapper">
    <svg className="icon icon__baths" xmlns="http://www.w3.org/2000/svg" width="28.96" height="30" viewBox="0 0 28.96 30">
      <path d="M27.75,14.36H3.62V4.7a2.41,2.41,0,1,1,4.83,0V6A1.63,1.63,0,0,0,7.36,7.12h3.38A1.63,1.63,0,0,0,9.65,6V4.7a3.62,3.62,0,1,0-7.24,0v9.65H1.21A1.13,1.13,0,0,0,0,15.56v4.82a7.24,7.24,0,0,0,3.62,6.28v1a2.41,2.41,0,1,0,4.83,0H20.51a2.41,2.41,0,1,0,4.83,0v-1A7.24,7.24,0,0,0,29,20.38V15.56a1.13,1.13,0,0,0-1.06-1.21h-.15ZM6,28.83a1.13,1.13,0,0,1-1.21-1.21v-.36a7.78,7.78,0,0,0,2.41.36,1.13,1.13,0,0,1-1.06,1.21H6Zm18.1-1.21a1.21,1.21,0,0,1-2.41,0,7.78,7.78,0,0,0,2.41-.36Zm2.41-9.88v2.64a4.83,4.83,0,0,1-4.83,4.83H7.24a4.83,4.83,0,0,1-4.83-4.83V16.77H26.55Z"/>
    </svg>
  </div>
);

export default () => {
  [...document.getElementsByTagName('BathsIcon')].forEach((el) => {
    render(BathsIcon, el, BathsIcon.children);
  });
};
